export default [
    {
        path: 'relatorio-cuidado-desenvolvimento-infantil',
        component: () => import(
            /* webpackChunkName: 'atencao-basica-relatorio-cuidado-desenvolvimento-infantil' */
            '@/views/atencao-basica/relatorio-cuidado-desenvolvimento-infantil/Index'
        ),
        redirect: { name: 'atencao-basica-relatorio-cuidado-desenvolvimento-infantil-index' },
        children: [
            {
                name: 'atencao-basica-relatorio-cuidado-desenvolvimento-infantil-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'atencao-basica-relatorio-cuidado-desenvolvimento-infantil' */
                    '@/views/atencao-basica/relatorio-cuidado-desenvolvimento-infantil/List.vue'
                ),
            },
        ],
    },
]